/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgOffcanvas = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M8 2v20H2V2zm14 0v20H10V2zM6 4H4v16h2zm14 0h-8v16h8zm-4 2v2h-2V6z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgOffcanvas as Offcanvas };
